"use strict";
// Very basic tokenizer and helpers (pure functions) — can be replaced with advanced NLP later.
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenizeSimple = tokenizeSimple;
exports.normalizeToken = normalizeToken;
function tokenizeSimple(text) {
    return text
        .replace(/\s+/g, " ")
        .trim()
        .split(/(?:(?<!\w)'\b|\b'(?=\w)|\W)+/) // split on non-word, but keep words like don't as two tokens
        .filter(Boolean)
        .map((w, i) => ({ value: w, index: i }));
}
function normalizeToken(t) {
    return t.toLowerCase();
}
//# sourceMappingURL=textProcessing.js.map